<template>
    <div>
      <div class="flex items-center justify-between mt-2">
        <page-header
          heading="Wallet"
          breadcrumb="Settings  >>  Payments >>  Wallet"
        />
    </div>
      <AllWallet/>
  
    </div>
  </template>
  
  <script>
  import PageHeader from "@/components/Ondemand/PageHeader";
  import AllWallet from "@/components/Ondemand/Settings/AllWallet.vue";
  
  export default { 
    components: {
      PageHeader,
      AllWallet
    },
    data(){
      return {
        isEmpty: false
      }
    }
  };  
  </script>
  
  <style></style>
  